export const ContributionStatus = {
  NEW: 'new',
  WITHDRAW: 'withdraw',
  TERMINATE: 'terminate',
  INCREASE: 'increase',
  DECREASE: 'decrease',
  RESET: 'reset',
  RESET_NEW: 'reset_new',
};
